import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchApps } from "@/lib/api";
import { ShieldCheck, Star, Users } from "lucide-react";
import Footer from "@/components/Footer";

export default function Developers() {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    fetchApps({ limit: 60 }).then(setApps);
  }, []);

  // Aggregate by developer
  const devs = Object.values(
    apps.reduce((acc, a) => {
      if (!acc[a.developer]) {
        acc[a.developer] = {
          name: a.developer,
          verified: a.developer_verified,
          apps: [],
          totalDownloads: 0,
          avgRating: 0,
        };
      }
      acc[a.developer].apps.push(a);
      acc[a.developer].totalDownloads += a.downloads;
      return acc;
    }, {})
  ).map((d) => ({
    ...d,
    avgRating: d.apps.reduce((s, a) => s + a.rating, 0) / d.apps.length,
  })).sort((a, b) => b.totalDownloads - a.totalDownloads);

  const fmt = (n) => n >= 1_000_000 ? `${(n / 1_000_000).toFixed(1)}M` : `${(n / 1_000).toFixed(1)}K`;

  return (
    <>
      <div className="max-w-7xl mx-auto px-6 pt-10">
        <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#00F0FF] mb-3">// developer spotlight</div>
        <h1 className="font-heading font-black text-5xl sm:text-6xl uppercase tracking-tighter">
          Independent Studios
        </h1>
        <p className="text-white/50 mt-2 max-w-lg">
          The makers behind the marketplace. Small teams shipping big drops.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-10">
          {devs.slice(0, 12).map((d) => (
            <div key={d.name} className="glass rounded-2xl p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#00F0FF] to-[#39FF14] flex items-center justify-center font-heading font-black text-black">
                  {d.name[0]}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <div className="font-heading font-bold text-lg truncate">{d.name}</div>
                    {d.verified && <ShieldCheck className="w-4 h-4 text-[#00F0FF]" />}
                  </div>
                  <div className="flex items-center gap-3 mono text-[10px] text-white/50 mt-0.5">
                    <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {fmt(d.totalDownloads)} launches</span>
                    <span className="flex items-center gap-1"><Star className="w-3 h-3 fill-[#FFE300] text-[#FFE300]" /> {d.avgRating.toFixed(1)}</span>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex gap-2 flex-wrap">
                {d.apps.slice(0, 4).map((a) => (
                  <Link key={a.slug} to={`/app/${a.slug}`} className="flex items-center gap-2 bg-white/5 border border-white/10 hover:border-[#00F0FF]/40 rounded-xl px-2.5 py-1.5 transition-colors">
                    <img src={a.icon_url} alt="" className="w-6 h-6 rounded" />
                    <span className="text-xs">{a.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
